// import React from 'react'

// export default function Banner2() {
//   return (
//     <section className="section-banner-two margin-tb-50">
//         <div className="container">
//           <div className="row">
//             <div className="col-12 banner-justify-box-contact">
//               <div className="banner-two-box">
//                 <span>25% Off</span>
//                 <h4>Fresh &amp; Organic vegetables</h4>
//                 <a href="#!" className="bb-btn-1">Shop Now</a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//   )
// }

import BeforeAfterSlider from "react-before-after-slider-component";
import "react-before-after-slider-component/dist/build.css";

import BEFORE_IMG from "../assets/after.jpg";
import AFTER_IMG from "../assets/before.jpg";

const FIRST_IMAGE = {
  imageUrl: 'https://example.com/.../some-image.jpg'
};
const SECOND_IMAGE = {
  imageUrl: 'https://example.com/.../some-image-2.jpg'
};

const HerbalPowderEffect = () => {
  return (
    <div className="container text-center my-5">
      <h3>Aura Skin Premium Effects</h3>
      <div className="mt-4">
        <BeforeAfterSlider
          firstImage={{ imageUrl: BEFORE_IMG }}
          secondImage={{ imageUrl: AFTER_IMG }}
          className="w-100"   // make responsive
        />
      </div>
    </div>
  );
};

export default HerbalPowderEffect;
